import { User } from "firebase/auth";
import { Messages, SendDateAndEventDateList, Token } from "../model/Message";
import { Company } from "../model/Companies";
import { ConstValue } from "../config/const";

export class MessagingCommonFunctions {
  main = () => {}

  // お知らせ登録処理
  submit = async (
    data: Messages,
    type: 'draft' | 'send' | 'preview',
    onlineUrlSelected: string | undefined,
    currentUser: User | null,
    selectedEventType: string,
    base64Image: string,
    company: Company | undefined,
    token: Token[],
    setToken: React.Dispatch<React.SetStateAction<Token[]>>,
    tokenState: string[],
    topicState: string[],
  ) => {
    // string型の日付けをDate型に変換
    data.sendDate = new Date(data.sendDate);
    // URLリンクボタン
    if(!data.urlButtonFlg || data.urlButtonFlg === undefined) {
      delete data.urlButtonFlg;
      delete data.urlButtonName;
      delete data.urlLink;
    };
    // 登録者
    data.authorUid = currentUser?.uid ?? "";
    data.authorName = currentUser?.displayName ?? '';
    // 登録団体
    data.tenantId = currentUser?.tenantId ?? "";
    // イベント時刻空欄フラグ
    data.isEventTimeEmpty = data.eventAtTime === undefined
      || data.eventAtTime === ''
      || data.eventEndAtTime === undefined
      || data.eventEndAtTime === '';
    // イベントタイプ
    data.eventType = selectedEventType;
    // 画像
    data.image = base64Image;
    // 配信先グループの登録
      if(data.select==='token'){
          data.topic=[];
          topicState=[];
    }else if(data.select==='topic'){
      if(topicState.length<=0){
        data.topic=[];
      }
      tokenState=[];
    }
    if(topicState.length > 0
      && data.topic !== undefined
      && !(data.topic.includes(company?.displayId!) || data.topic.includes('all'))){
      data.topic = topicState.filter((topic) => topic !== company?.displayId);
    };
    // 個別配信登録
    if(tokenState.length > 0
      && data.topic !== undefined
      && !(data.topic.includes(company?.displayId!) || data.topic.includes('all'))){
      if(type !== 'send'){
        token = [];
        token = tokenState.map((userId) => {
          return {
            tenantId: company?.id ?? '',
            deliveredFlg: false,
            sendDate: data.sendDate,
            userId: userId,
            eventAt: data.eventAt,
            eventFlg: data.eventFlg,
          };
        });
      };
      token.sort((a, b) => Number(a.userId) - Number(b.userId));
      setToken([...new Set(token)]);
    } else {
      token = [];
      setToken([]);
    };
    console.log(token)
    // 配信先設定フェイルセーフ
    if(type !== 'draft' && (data.topic?.length ?? 0) === 0 && token.length === 0) {
      data.topic = [company?.displayId!];
    };

    if(type !== 'preview') {
      // ミーティングURL
      const link = onlineUrlSelected !== '' ? onlineUrlSelected : data.url;
      data.link = link?.match(/^https:\/\/$/) !== null || link === undefined  ? '' : link;
      // 配信日時
      delete data.sendDateTime;
      // イベント開始日時
      delete data.eventAtTime;
      // イベント終了日時
      delete data.eventEndAtTime;
      // 掲載終了日時
      if(data.publishEndAt !== undefined){
        data.publishEndAt = new Date(data.publishEndAt);
        delete data.publishEndAtTime;
      } else {
        delete data.publishEndAt;
        delete data.publishEndAtTime;
      };
      // 下書き・新規登録
      data.draftFlg = type === 'draft';
    }
    
    // 配信日のリストを作成
    let sendDateList: SendDateAndEventDateList[]
       = [{sendDate: data.sendDate, eventAt: new Date(data.eventAt), eventEndAt: new Date(data.eventEndAt)}];

    return {sendDateList, sendData: data, sendToken: token};
  };

  imageFileToBase64Image = (file: File, setBase64Image: React.Dispatch<React.SetStateAction<string>>) => {
    const img = new Image();
    img.onload = () => {
      // アップロードできる最大サイズ
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      const maxW = ConstValue.IMG_MAX_WH;
      const maxH = ConstValue.IMG_MAX_WH;
      const iw = img.width;
      const ih = img.height;

      let iwScaled = iw;
      let ihScaled = ih;
      if(maxW < iw || maxH < ih) {
        // 縦横いずれかが最大幅を超える場合、リサイズ
        let scale = Math.min((maxW/iw), (maxH/ih));
        iwScaled = iw * scale;
        ihScaled = ih * scale;
      }
      canvas.width = iwScaled;
      canvas.height = ihScaled;
      ctx?.drawImage(img, 0, 0, iwScaled, ihScaled);

      // ファイルサイズが指定値を下回るまで 品質を 0.1 ずつ低下させる
      let base64Str;
      let quality = 0.9;
      do {
        base64Str = canvas.toDataURL('image/jpeg', quality);
        console.debug(` -- Base64Size：${base64Str.length} / 品質：${quality}`);
        quality = quality - 0.1;
      } while (base64Str.length > ConstValue.IMG_MAX_FILE_SIZE);

      console.log(` -- Base64Size：${base64Str.length} / 品質：${quality + 0.1} / width：${iwScaled} / height：${ihScaled}`);
      setBase64Image(base64Str);
    };
    img.src = URL.createObjectURL(file);
  };
};